import InfoIcon from '@material-ui/icons/Info';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Dialog from '@material-ui/core/Dialog';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import Menu from '../../../shared/components/_controls/Menu/Menu';
import EmptyState from 'modules/shared/components/_states/EmptyState/EmptyState';
import LoadingState from 'modules/shared/components/_states/LoadingState/LoadingState';
import ConfirmDialogComponent from 'modules/shared/components/confirm-dialog/ConfirmDialogComponent';
import TemplateDialogContainer from '../template-dialog/TemplateDialogContainer';
import TemplateInfoDialog from '../template-info-dialog/TemplateInfoDialog';
import EmptyTemplateImg from 'assets/img/app_states/empty/No-History.png';
function TemplateList(props) {
  return (
    <div id="RolesList">
      {!props.isLoading ? (
        props.templates.length > 0 ? (
          <div className="rolesContainer">
            {props.templates.map((template, idx) => (
              <div key={idx} className="roleContainer">
                <div className="RoleName">{template.name}</div>
                <div className="menuContainer">
                  <Menu>
                    <div
                      className="CustommenuItem"
                      onClick={() => {
                        props.templateInfoFunction(template);
                      }}
                    >
                      <InfoIcon />
                      <span style={{ marginLeft: '16px' }}>Info</span>
                    </div>
                    <div
                      className="CustommenuItem"
                      onClick={() => props.openTemplateDialog(template)}
                    >
                      <EditIcon />
                      <span style={{ marginLeft: '16px' }}>Edit</span>
                    </div>
                    <div className="CustommenuItem" onClick={() => props.confirmDelete(template)}>
                      <DeleteIcon />
                      <span style={{ marginLeft: '16px' }}>Delete</span>
                    </div>
                  </Menu>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <EmptyState
            stateImage={
              <div>
                <img src={EmptyTemplateImg} alt="emptyTemplate" />
              </div>
            }
            stateText={
              <div className="empty-text-section">
                <div
                  style={{ marginBottom: '0.75em', font: '400 15px/24px "Poppins", sans-serif' }}
                  className="empty-text-message"
                >
                  No template found.
                </div>
              </div>
            }
          />
        )
      ) : (
        <LoadingState />
      )}
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={props.isDialogOpen}
        onBackdropClick={props.closeTemplateDialog}
        aria-labelledby="form-dialog-title"
      >
        <TemplateDialogContainer
          data={props.dialogData}
          closeDialog={props.closeTemplateDialog}
          onTemplateCreate={props.onTemplateCreate}
          fetchData={props.fetchData}
        />
      </Dialog>
      <Dialog open={props.isDeleteDialogOpen} onBackdropClick={props.closeDeleteDialog}>
        <ConfirmDialogComponent data={props.toDelete} close={props.closeDeleteDialog} />
      </Dialog>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={props.isTemplateInfoDialogOpen}
        onBackdropClick={props.closeTemplateInfoDialog}
      >
        <TemplateInfoDialog
          template={props?.templateInformation}
          close={props.closeTemplateInfoDialog}
        />
      </Dialog>

      <Snackbar
        open={props.showSuccessToast}
        autoHideDuration={1000}
        onClose={props.closeSuccessToast}
      >
        <Alert onClose={props.closeSuccessToast} severity={'success'}>
          {props.successToastText}
        </Alert>
      </Snackbar>

      <Snackbar open={props.showErrorToast} autoHideDuration={1000} onClose={props.closeErrorToast}>
        <Alert onClose={props.closeErrorToast} severity={'error'}>
          {props.errorToastText}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default TemplateList;
